import { Select, Spin } from "antd";
import React, { useMemo } from "react";
import { DefaultOptionType } from "rc-select/lib/Select";
import useAllMembers from "../../Members/useAllMembers";

function MemberSelector(props: {
  readOnly: boolean;
  onChange: (membersIds: string[]) => void;
  preSelectedMembersIds: string[];
}) {
  const { data: members, allMembersLoaded } = useAllMembers(
    localStorage.getItem("guild-id") || ""
  );

  const memberOptions: DefaultOptionType[] = useMemo(() => {
    return members
      .map((member) => ({
        label: member.username,
        value: member.discord_id,
      }))
      .concat([{ label: "{{username}}", value: "{{user.id}}" }]);
  }, [members]);

  return (
    <Spin spinning={!allMembersLoaded} wrapperClassName={"w-full"}>
      <Select
        mode="multiple"
        placeholder="Please select a member"
        aria-readonly={props.readOnly}
        onChange={props.onChange}
        className={"w-full"}
        filterOption={(input, option) =>
          option?.label
            ?.toString()
            .toLowerCase()
            .indexOf(input.toLowerCase())! >= 0
        }
        disabled={props.readOnly}
        defaultValue={props.preSelectedMembersIds}
        options={memberOptions}
      />
    </Spin>
  );
}

export default MemberSelector;
